import find from 'lodash/find';
import { PRODUCT_VARIANT_NAME_PARAM_HASH } from '@/constants/ProductConstants';

const ProductTitle = ({ product }) => {
  const productParams = product?.detailedParameters || product?.cardParameters;
  const nameParameter = find(productParams, { hash: PRODUCT_VARIANT_NAME_PARAM_HASH });
  return nameParameter?.value || product?.name;
}

export default ProductTitle;
